export { default as CaseHeadsUpNoteBar } from './CaseHeadsUpNoteBar';
export { default as CreateHeadsUpNoteButton } from './CreateHeadsUpNoteButton';
export { default as CaseHeadsUpNoteModal } from './CaseHeadsUpNoteModal';
export { default as withCaseHeadsUpNote } from './withCaseHeadsUpNote';



// WEBPACK FOOTER //
// ./src/compositions/CaseHeadsUpNote/index.js